import { Link } from 'react-router';
import { ExperienceCard } from '@/components/ExperienceCard';
import { useExperiences } from '@/hooks/useExperiences';

/**
 * Public landing page. Leads with the hero, then previews a handful of
 * featured experiences before handing off to the full catalog.
 */
export function PageHome() {
  const { experiences } = useExperiences();

  const featured = experiences
    .filter((e) => typeof e.featuredOrder === 'number' && e.status === 'active')
    .sort((a, b) => a.featuredOrder! - b.featuredOrder!);

  return (
    <>
      {/* Hero */}
      <section className='tw:relative tw:flex tw:min-h-[45vh] tw:items-center tw:justify-center tw:overflow-hidden tw:bg-[linear-gradient(135deg,rgba(26,26,26,0.95)_0%,rgba(45,45,45,0.9)_50%,rgba(26,26,26,0.95)_100%)]'>
        <div className='tw:absolute tw:inset-0 tw:opacity-20'>
          <img
            src='https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?q=80&w=2000&auto=format&fit=crop'
            alt='Japan'
            className='tw:h-full tw:w-full tw:object-cover'
          />
        </div>
        <div className='tw:absolute tw:inset-0 tw:bg-linear-to-b tw:from-ed-black/60 tw:via-ed-black/40 tw:to-ed-black/90' />

        <div className='tw:relative tw:z-10 tw:mx-auto tw:max-w-5xl tw:px-6 tw:text-center'>
          <span className='tw:mb-6 tw:inline-block tw:text-xs tw:font-bold tw:tracking-[0.4em] tw:text-ed-gold tw:uppercase'>
            For Partners
          </span>
          <h1 className='tw:mb-6 tw:font-serif tw:text-5xl tw:leading-tight tw:text-white tw:md:text-7xl tw:lg:text-8xl'>
            Exclusive{' '}<span className='tw:text-ed-gold tw:italic'>Experiences</span>
          </h1>
          <p className='tw:mx-auto tw:mb-12 tw:max-w-2xl tw:text-lg tw:leading-relaxed tw:text-white/70 tw:md:text-xl'>
            Curated cultural immersions across Japan, available exclusively to our partners
            and their guests.
          </p>
        </div>
      </section>

      {/* Featured standalone experiences */}
      {featured.length > 0 && (
        <section className='tw:mx-auto tw:max-w-6xl tw:px-6 tw:py-20'>
          <div className='tw:mb-12 tw:text-center'>
            <p className='tw:text-xs tw:tracking-[0.3em] tw:uppercase tw:text-ed-gold'>Selected</p>
            <h2 className='tw:mt-3 tw:font-serif tw:text-4xl tw:font-light'>Featured Experiences</h2>
          </div>
          <div className='tw:grid tw:gap-8 tw:md:grid-cols-3'>
            {featured.map((experience) => (
              <ExperienceCard key={experience.id} experience={experience} />
            ))}
          </div>
        </section>
      )}

      {/* Shared CTA to the full catalog */}
      <section className='tw:px-6 tw:py-16 tw:text-center'>
        <Link
          to='/catalog'
          className='tw:text-sm tw:tracking-[0.2em] tw:uppercase tw:text-ed-black tw:underline tw:decoration-ed-gold tw:underline-offset-8 tw:hover:text-ed-gold'
        >
          View the full catalog
        </Link>
      </section>
    </>
  );
}
